<!-- Section for icon/type selection -->
<section id="type-selection">
    <h3>Soort</h3>
    <section>
        <ng-container *ngFor="let type of _types">
            <div class="comment-type" [class.selected]="type.id | equals: _selectedType" (click)="_handleClickType(type)">
                <i [class]="type.icon | concat: ' icon'" [style.color]="type.color"></i>
                <span>{{ type.name }}</span>
            </div>
        </ng-container>
    </section>
</section>

<!-- Comment text -->
<section id="text">
    <h3>Tekst</h3>
    <div>
        <multi-line-text-input [(value)]="_text" (keydown.enter)="_stopPropagation($event)"></multi-line-text-input>
    </div>
</section>

<!-- Footer with buttons -->
<footer>
    <div class="button" (click)="_handleClickDone()">
        <span>Opslaan</span>
    </div>
</footer>